<template>
  <div class="container">
    <div class="tab-container">


      <el-tabs :tab-position="isMobile ? 'top' : 'left'" :style="isMobile ? {} : {height: 'auto'}"
               v-model="activeSection" @tab-click="handleTabClick">
        <el-tab-pane label="Company Details" name="section1"></el-tab-pane>
        <el-tab-pane label="Payment Service Requests" name="section2"></el-tab-pane>
        <el-tab-pane label="Business Information" name="section3"></el-tab-pane>
        <el-tab-pane label="Account Setup" name="section4"></el-tab-pane>
        <el-tab-pane label="KYC Documentation" name="section5"></el-tab-pane>

        <el-tab-pane :label="'Declarations and Authorizations'" name="section6"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="form-container">
      <el-card v-loading = 'loading'>
        <div class="space-y-8">
          <div>
            <img class="h-12 w-auto mx-auto" :src="latipayLogo" alt="Latipay logo with purple and green text">
            <h1 class="mt-6  text-3xl font-extrabold text-gray-900">Merchant Onboarding Application Form</h1>
          </div>

          <div v-if="isDevMode" style="text-align: left; margin-top: -12px;">
            <el-button size="small" type="warning" plain @click="fillMockData">
              🧪 Auto Fill Test Data
            </el-button>
          </div>
          <div v-show="activePage === '1'">
            <div>
              <h2 class="section-title text-lg font-medium text-gray-900 border-b pb-2" style="text-align: left">Section 1 Company
                Details</h2>

              <el-form :model="form" :rules="formRules" ref="formRef" label-position="top" class="mt-8 space-y-6"
                       style="text-align: left" id="form">

                <el-form-item label="Legal Business Name (as registered)" required prop="legalBusinessName">
                  <el-input v-model="form.legalBusinessName"></el-input>
                </el-form-item>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="Trading Name (if different from Legal Name)" required prop="tradingName">
                      <el-input v-model="form.tradingName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Country of Incorporation" required prop="countryOfIncorporation">
                      <el-select v-model="form.countryOfIncorporation" placeholder="Please Select">
                        <el-option label="New Zealand" value="NZ"></el-option>
                        <el-option label="Australia" value="AU"></el-option>
                        <el-option label="Hong Kong" value="HK"></el-option>
                        <el-option label="Others" value="OTHER"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">

                    <el-form-item label="Others Country" required v-if="form.countryOfIncorporation === 'OTHER'" prop="countryOfIncorporationOther">
                      <el-input v-model="form.countryOfIncorporationOther" placeholder="Others; Please specify"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="Company Registration Number" required prop="companyRegistrationNumber">
                      <el-input v-model="form.companyRegistrationNumber"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Date of Incorporation" required prop="dateOfIncorporation">
                      <el-date-picker v-model="form.dateOfIncorporation" style="width: 100%" type="date"
                                      value-format="YYYY-MM-DD"
                                      placeholder="Select date"></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="Business Type" required prop="businessType">
                      <el-select v-model="form.businessType" placeholder="Please Select">
                        <el-option label="Sole Trader" value="SOLE_TRADER"></el-option>
                        <el-option label="Partnership" value="PARTNERSHIP"></el-option>
                        <el-option label="Limited Company" value="LIMITED_COMPANY"></el-option>
                        <el-option label="Corporation" value="CORPORATION"></el-option>
                        <el-option label="Non-Profit Organizations" value="NONPROFIT"></el-option>
                        <el-option label="Public Listed Company" value="PUBLICLISTED"></el-option>
                        <el-option label="Others" value="OTHER"></el-option>

                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Others" required v-if="form.businessType === 'OTHER'" prop="businessTypeOther">
                      <el-input v-model="form.businessTypeOther" placeholder="Others; Please specify"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="Registered Business Address" required prop="registeredAddress">
                  <el-form-item prop="registeredAddress.street" style="width: 100%">
                    <el-input
                        v-model="form.registeredAddress.street"
                        placeholder="Street Address"
                        style="margin-bottom: 15px;"
                    ></el-input>
                  </el-form-item>

                  <el-form-item prop="registeredAddress.street2" style="width: 100%">
                    <el-input
                        v-model="form.registeredAddress.street2"
                        placeholder="Street Address Line 2"
                        style="margin-bottom: 15px"
                    ></el-input>
                  </el-form-item>


                  <el-row :gutter="20" style="width: 100%">
                    <el-col :span="6">
                      <el-form-item prop="registeredAddress.city" style="width: 100%">
                        <el-input
                            v-model="form.registeredAddress.city"
                            placeholder="City"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item prop="registeredAddress.state" style="width: 100%">
                        <el-input
                            v-model="form.registeredAddress.state"
                            placeholder="State"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6" v-if="form.countryOfIncorporation !== 'HK'">
                      <el-form-item prop="registeredAddress.postalCode" style="width: 100%">
                        <el-input
                            v-model="form.registeredAddress.postalCode"
                            placeholder="Postal / Zip Code"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item prop="registeredAddress.country">
                        <el-select
                            v-model="form.registeredAddress.country"
                            placeholder="Select Country"
                            filterable
                            style="width: 100%"
                        >
                          <el-option
                              v-for="country in countryOptions"
                              :key="country.Code"
                              :label="country.Name"
                              :value="country.Code"
                          ></el-option>


                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item label="Operational / Trading Address" required prop="operationalAddress">
                  <el-form-item prop="operationalAddress.street" style="width: 100%">
                    <el-input v-model="form.operationalAddress.street" placeholder="Street Address"
                              style="margin-bottom: 15px"></el-input>
                  </el-form-item>

                  <el-form-item prop="operationalAddress.street2" style="width: 100%">
                    <el-input v-model="form.operationalAddress.street2" placeholder="Street Address Line 2"
                              style="margin-bottom: 15px"></el-input>
                  </el-form-item>


                  <el-row :gutter="20" style="width: 100%">
                    <el-col :span="6">
                      <el-form-item prop="operationalAddress.city" style="width: 100%">
                        <el-input v-model="form.operationalAddress.city" placeholder="City"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item prop="operationalAddress.state" style="width: 100%">
                        <el-input v-model="form.operationalAddress.state" placeholder="State"></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="6" v-if="form.countryOfIncorporation !== 'HK'">
                      <el-form-item prop="operationalAddress.postalCode" style="width: 100%">
                        <el-input v-model="form.operationalAddress.postalCode"
                                  placeholder="Postal / Zip Code"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item prop="operationalAddress.country" style="width: 100%">
                        <el-select
                            v-model="form.operationalAddress.country"
                            placeholder="Select Country"
                            filterable
                        >
                          <el-option
                              v-for="country in countryOptions"
                              :key="country.Code"
                              :label="country.Name"
                              :value="country.Code"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item>
                  <el-checkbox class="checkbox-block" v-model="form.sameAddress">Same address as Registered Business Address</el-checkbox>
                </el-form-item>
                <el-form-item>
                  <el-checkbox class="checkbox-block" v-model="form.tradingAddressResidential">Trading address is a residential premises
                  </el-checkbox>
                </el-form-item>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="Business Phone Number" required prop="businessPhone">
                      <el-input
                          v-model="form.businessPhone"
                          style="max-width: 600px"
                          placeholder="Please input phone number"
                          class="input-with-select"
                      >
                        <template #prepend>
                          <el-select v-model="form.businessPhoneCountryCode" placeholder="Country Dial"
                                     filterable
                                     style="width: 150px;background-color: var(--el-fill-color-blank);">
                            <!--                            <el-option-->
                            <!--                                v-for="country in dialOptions"-->
                            <!--                                :key="country.code"-->
                            <!--                                :label="country.dial_code"-->
                            <!--                                :value="country.dial_code"-->
                            <!--                            ></el-option>-->
                            <el-option label="Australia(+61)" value="+61"></el-option>
                            <el-option label="New Zealand(+64)" value="+64"></el-option>
                            <el-option label="Hong Kong(+852)" value="+852"></el-option>
                            <el-option label="China(+86)" value="+86"></el-option>
                            <el-option label="United States(+1)" value="+1"></el-option>
                            <el-option label="Canada(+1)" value="+1"></el-option>
                            <el-option label="Singapore(+65)" value="+65"></el-option>
                            <el-option label="United Kingdom(+44)" value="+44"></el-option>
                          </el-select>
                        </template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Business Email Address" required prop="businessEmail">
                      <el-input v-model="form.businessEmail" placeholder="example@example.com"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <h4 class="text-lg font-medium text-gray-900">Primary Contact Person</h4>
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item label="First Name" required prop="contactPerson.firstName">
                      <el-input v-model="form.contactPerson.firstName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="Middle Name" prop="contactPerson.middleName">
                      <el-input v-model="form.contactPerson.middleName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="Last Name" required prop="contactPerson.lastName">
                      <el-input v-model="form.contactPerson.lastName"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="Phone Number" required prop="contactPerson.phone">

                      <el-input
                          v-model="form.contactPerson.phone"
                          style="max-width: 600px"
                          placeholder="Please input phone number"
                          class="input-with-select"
                      >
                        <template #prepend>
                          <el-select v-model="form.contactPerson.phoneCountryCode" placeholder="Country Dial"
                                     filterable
                                     style="width: 150px;background-color: var(--el-fill-color-blank);">
                            <el-option label="Australia(+61)" value="+61"></el-option>
                            <el-option label="New Zealand(+64)" value="+64"></el-option>
                            <el-option label="Hong Kong(+852)" value="+852"></el-option>
                            <el-option label="China(+86)" value="+86"></el-option>
                            <el-option label="United States(+1)" value="+1"></el-option>
                            <el-option label="Canada(+1)" value="+1"></el-option>
                            <el-option label="Singapore(+65)" value="+65"></el-option>
                            <el-option label="United Kingdom(+44)" value="+44"></el-option>
                          </el-select>
                        </template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Email" required prop="contactPerson.email">
                      <el-input v-model="form.contactPerson.email" placeholder="example@example.com"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="Position" required prop="contactPerson.position">
                      <el-input v-model="form.contactPerson.position"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item style="float: right">
                  <el-button type="primary" @click="onToPageTwo">Next</el-button>
                </el-form-item>

              </el-form>
            </div>
          </div>
        </div>
        <div v-show="activePage === '2' || activeSection === 'section2'">
          <h2 class="section-title text-lg font-medium text-gray-900 border-b pb-2" style="text-align: left">Section 2 Payment Service Requests</h2>
          <el-form :model="sectionTwoForm" label-position="top" style="text-align: left" ref="sectionTwoFormRef"
                   :rules="sectionTwoFormRules" id="sectionTwoForm">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="Online Payment Methods">
                  <el-checkbox v-if="(form.countryOfIncorporation !== 'OTHER') || !form.countryOfIncorporation"
                               v-model="sectionTwoForm.onlinePayments.vm" label="Visa/Mastercard"></el-checkbox>
                  <el-checkbox v-if="(form.countryOfIncorporation === 'NZ') || !form.countryOfIncorporation"
                               v-model="sectionTwoForm.onlinePayments.polipay" label="Polipay"></el-checkbox>
                  <el-checkbox
                      v-if="(form.countryOfIncorporation === 'NZ' || form.countryOfIncorporation === 'AU') || !form.countryOfIncorporation"
                      v-model="sectionTwoForm.onlinePayments.wechat" label="WeChat Pay"></el-checkbox>
                  <el-checkbox
                      v-if="(form.countryOfIncorporation === 'NZ' || form.countryOfIncorporation === 'AU') || !form.countryOfIncorporation"
                      v-model="sectionTwoForm.onlinePayments.alipay" label="Alipay"></el-checkbox>
                  <el-checkbox v-if="form.countryOfIncorporation !== 'NZ'"
                               v-model="sectionTwoForm.onlinePayments.payID" label="PayID"></el-checkbox>
                  <el-checkbox
                      v-if="(form.countryOfIncorporation === 'NZ' || form.countryOfIncorporation === 'AU') || !form.countryOfIncorporation"
                      v-model="sectionTwoForm.onlinePayments.unionpay" label="Unionpay"></el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="12">

                <el-form-item label="Offline-In Store Payment Methods">
                  <el-checkbox v-if="(form.countryOfIncorporation === 'NZ') ||  !form.countryOfIncorporation"
                               v-model="sectionTwoForm.offlinePayments.polipay" label="Polipay"></el-checkbox>
                  <el-checkbox
                      v-if="(form.countryOfIncorporation === 'NZ' || form.countryOfIncorporation === 'AU') || !form.countryOfIncorporation"
                      v-model="sectionTwoForm.offlinePayments.wechat" label="WeChat Pay"></el-checkbox>
                  <el-checkbox
                      v-if="(form.countryOfIncorporation === 'NZ' || form.countryOfIncorporation === 'AU') || !form.countryOfIncorporation"
                      v-model="sectionTwoForm.offlinePayments.alipayPlus" label="Alipay+"></el-checkbox>
                  <el-checkbox v-if="form.countryOfIncorporation !== 'NZ'"
                               v-model="sectionTwoForm.offlinePayments.payID" label="PayID"></el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20" style="margin-top: 20px;">
              <el-col :span="12">
                <img class="h-12 w-auto mx-auto" :src="pmLogo" alt="Latipay payment methods" style="width: 250px;">
              </el-col>

              <el-col :span="12">
                <div>
                  Alipay+ includes <strong>Alipay</strong>, <strong>AlipayHK</strong> (Hong Kong),
                  <strong>TrueMoney</strong> (Thailand), <strong>Kakao Pay</strong> (South Korea),
                  <strong>GCash</strong> (Philippines), <strong>TNG eWallet</strong> (Malaysia), <strong>MPay</strong>
                  (Macau), <strong>OCBC Bank</strong> (Singapore), <strong>ChangiPay</strong> (Singapore),
                  <strong>HiPay</strong> (Mongolia), <strong>TossPay</strong> (South Korea), <strong>NaverPay</strong>
                  (South Korea), <strong>Public Bank</strong> (Malaysia)
                </div>
              </el-col>

            </el-row>

            <div v-if="sectionTwoForm.onlinePayments.vm">

              <h3 style="margin-top: 20px;">For Visa/Mastercard, please provide the following information</h3>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="1. Product/Services Provided" required prop="products">
                    <el-input v-model="sectionTwoForm.products" type="textarea" rows="1"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="2. Target Markets" required prop="markets">
                    <el-input v-model="sectionTwoForm.markets" type="textarea" rows="1"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item label="3. Advertising Channels" required prop="channels">
                <el-input v-model="sectionTwoForm.channels" type="textarea" rows="1"></el-input>
              </el-form-item>

              <el-form-item label="4. Current Acquirer (Card Payment Service Provider)" required prop="acquirer">
                <el-input v-model="sectionTwoForm.acquirer" type="textarea" rows="1"></el-input>

                <span>Please note that we might ask for Merchant Statements after evaluating your application.</span>
                <p class="text-sm text-gray-600" style="margin-top: -6px;">
                  New business with no transaction history? Please provide your best estimate based on projections.
                </p>
              </el-form-item>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item required prop="annualCardTurnover">
                    <template #label>
                      <span class="field-label-with-info">
                        5. Annual Card Turnover
                        <el-tooltip effect="dark" placement="top"
                                    :content="'Total yearly sales volume via Visa/Mastercard' + (localCurrency ? ', in ' + localCurrency : ', in your local currency')">
                          <el-icon class="field-info-icon"><InfoFilled/></el-icon>
                        </el-tooltip>
                      </span>
                    </template>
                    <el-input v-model="sectionTwoForm.annualCardTurnover">
                      <template v-if="localCurrency" #prepend>{{ localCurrency }}</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item required prop="avgMonthlyTransactionValue">
                    <template #label>
                      <span class="field-label-with-info">
                        6. Average Ticket Size
                        <el-tooltip effect="dark" placement="top"
                                    :content="localCurrency ? 'In ' + localCurrency : 'In your local currency'">
                          <el-icon class="field-info-icon"><InfoFilled/></el-icon>
                        </el-tooltip>
                      </span>
                    </template>
                    <el-input v-model="sectionTwoForm.avgMonthlyTransactionValue">
                      <template v-if="localCurrency" #prepend>{{ localCurrency }}</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item label="7. Delivery Timeframe" required prop="deliveryTimeframe">
                <el-input v-model="sectionTwoForm.deliveryTimeframe" placeholder="e.g. 3 days"></el-input>
              </el-form-item>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="8. Chargeback Rate (%)" required prop="estMonthlyChargebackValue">
                    <el-input v-model="sectionTwoForm.estMonthlyChargebackValue"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="9. Refund Rate (%)" required prop="estMonthlyRefundsValue">
                    <el-input v-model="sectionTwoForm.estMonthlyRefundsValue"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item label="10. Dispute Timing" required prop="disputeTiming">
                <el-radio-group v-model="sectionTwoForm.disputeTiming">
                  <el-radio label="0-14">0-14 days</el-radio>
                  <el-radio label="15-30">15-30 days</el-radio>
                  <el-radio label="31-60">31-60 days</el-radio>
                  <el-radio label="61-120">61-120 days</el-radio>
                  <el-radio label="120+">120 days +</el-radio>
                </el-radio-group>
              </el-form-item>




            </div>
            <el-row style="margin-top: 20px;">
              <el-col :span="12">
                <el-button @click="onBackPageOne">Back</el-button>
              </el-col>
              <el-col :span="12" style="text-align: right;">
                <el-button type="primary" @click="onToPageThree">Next</el-button>
              </el-col>
            </el-row>
          </el-form>


        </div>
        <div v-show="activePage === '3' || activeSection === 'section3'">
          <h2 class="section-title text-2xl font-semibold mb-6" style="text-align: left">Section 3 Business Information</h2>

          <el-form label-position="top" style="text-align: left" :model="sectionThreeForm" ref="sectionThreeFormRef"
                   :rules="sectionThreeFormRules" id="sectionThreeForm">
            <el-form-item label="Nature of Business" required prop="businessCategory">
              <el-radio-group v-model="sectionThreeForm.businessCategory">
                <el-radio v-for="category in categories" :key="category" :label="category">{{ category }}</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="Business Operation Type" required prop="businessOperation">
              <el-radio-group v-model="sectionThreeForm.businessOperation">
                <el-radio v-for="operation in operations" :key="operation" :label="operation">{{ operation }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <div
                v-if="sectionThreeForm.businessOperation === 'Brick-and Mortar Store (physical storefront, customers visit in person)' ">

              <h2 class="text-lg font-semibold mt-6 mb-2">Brick-and Mortar Store</h2>
              <p class="text-sm text-gray-600 mb-4">(physical storefront, customers visit in person)</p>

              <el-form-item label="1. Please describe the type of products or services you offer" required
                            prop="bm_productsServices">
                <el-input type="textarea" v-model="sectionThreeForm.bm_productsServices" :rows="3"></el-input>
              </el-form-item>

              <el-form-item label="2. Please prepare two recent photos of your storefront" required>
                <p class="text-xs text-gray-600 mt-2">1.Exterior: Clearly showing the storefront with visible signage
                  <br/>2.Interior: Displaying your products or Service</p>
              </el-form-item>

              <el-form-item label="3. Do you have a website or online store link?" required prop="bm_hasWebsite">
                <el-radio-group v-model="sectionThreeForm.bm_hasWebsite">
                  <el-radio label="yes">Yes</el-radio>
                  <el-radio label="no">No, I conduct business through social media or other channels</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item v-if="sectionThreeForm.bm_hasWebsite === 'yes'" label="Website or Online Store Link"
                            required prop="bm_websiteLink">
                <el-input v-model="sectionThreeForm.bm_websiteLink"></el-input>
              </el-form-item>
            </div>
            <div
                v-if="sectionThreeForm.businessOperation === 'Home-Based Business (Operates primarily from a residential address)' ">

              <h2 class="text-lg font-semibold mt-6 mb-2">Home-Based Business</h2>
              <p class="text-sm text-gray-600 mb-4">(Operates primarily from a residential address)</p>

              <el-form-item label="1. Please describe the type of products or services you offer" required
                            prop="hb_productsServices">
                <el-input type="textarea" v-model="sectionThreeForm.hb_productsServices" :rows="3"></el-input>
                <span>Please prepare some invoices demonstrating operational activity.</span>
              </el-form-item>

              <el-form-item label="2. Do customers visit your home for transactions?" required prop="hb_vistHome">
                <el-radio-group v-model="sectionThreeForm.hb_vistHome">
                  <el-radio label="yes">Yes, occasionally</el-radio>
                  <el-radio label="no">No, all business is conducted remotely (online or by phone)</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="3. Do you have a website or online store link?" required prop="hb_hasWebsite">
                <el-radio-group v-model="sectionThreeForm.hb_hasWebsite">
                  <el-radio label="yes">Yes</el-radio>
                  <el-radio label="no">No, I conduct business through social media or other channels</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item v-if="sectionThreeForm.hb_hasWebsite === 'yes'" label="Website or Online Store Link"
                            required prop="hb_websiteLink">
                <el-input v-model="sectionThreeForm.hb_websiteLink"></el-input>
              </el-form-item>

            </div>

            <div
                v-if="sectionThreeForm.businessOperation === 'Online-Only Business (No Physical storefront, operates entirely online)' ">

              <h2 class="text-lg font-semibold mt-6 mb-2">Online-Only Business</h2>
              <p class="text-sm text-gray-600 mb-4">(No Physical storefront, operates entirely online)</p>

              <el-form-item label="1. Please describe the type of products or services you offer" required
                            prop="ob_productsServices">
                <el-input type="textarea" v-model="sectionThreeForm.ob_productsServices" :rows="3"></el-input>
              </el-form-item>
              <el-form-item label="2. Please provide your business website or online store URL" required
                            prop="ob_websiteLink">
                <el-input v-model="sectionThreeForm.ob_websiteLink"></el-input>
              </el-form-item>

              <el-form-item label="3. What platform do you primarily use to sell your products or services?" required
                            prop="ob_platform">
                <el-radio-group v-model="sectionThreeForm.ob_platform">
                  <el-radio label="own">Own Website (e.g., Wordpress,Shopify)</el-radio>
                  <el-radio label="marketplace">Marketplace</el-radio>
                  <el-radio label="social">Social Media (e.g., Instagram, Facebook, Littleredbook)</el-radio>
                  <el-radio label="other">Other</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if="sectionThreeForm.ob_platform === 'other'" label="3. Other platform" required
                            prop="ob_platform_other">
                <el-input v-model="sectionThreeForm.ob_platform_other"></el-input>
              </el-form-item>

              <el-form-item label="4. Do you ship products internationally?" required prop="ob_international">
                <el-radio-group v-model="sectionThreeForm.ob_international">
                  <el-radio label="yes_globally">Yes, globally</el-radio>
                  <el-radio label="yes_limited">Yes, but limited to certain regions</el-radio>
                  <el-radio label="no_only">No, only within my country</el-radio>
                  <el-radio label="no_physical">No physical products to be ship</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div v-if="sectionThreeForm.businessOperation === 'Mixed/Service-Based Business (Combines Physical, Online, or service-based operations)'">
<!--            <div v-if="sectionThreeForm.businessOperation === 'Mixed (Both Online and Physical Location)' ">-->

              <h2 class="text-lg font-semibold mt-6 mb-2">Mixed</h2>
              <p class="text-sm text-gray-600 mb-4">(Combines Physical, Online, or service-based operations)</p>

              <el-form-item label="1. Please describe the type of products or services you offer" required
                            prop="mix_productsServices">
                <el-input type="textarea" v-model="sectionThreeForm.mix_productsServices" :rows="3"></el-input>
              </el-form-item>


              <el-form-item label="2. Please provide your business website or online store URL" required
                            prop="mix_websiteLink">
                <el-input v-model="sectionThreeForm.mix_websiteLink"></el-input>
              </el-form-item>
              <el-form-item label="3. Please prepare two recent photos of your storefront" required>
                <p class="text-xs text-gray-600 mt-2">1.Exterior: Clearly showing the storefront with visible signage
                  <br/>2.Interior: Displaying your products or Service</p>
              </el-form-item>

              <el-form-item label="4. What percentage of your sales come from - instore versus online?" required
                            prop="mix_salesFrom">
                <el-radio-group v-model="sectionThreeForm.mix_salesFrom">
                  <el-radio label="over70Offline">Mostly in-store (over 70% in-store)</el-radio>
                  <el-radio label="over70Online">Mostly online (over 70% online)</el-radio>
                  <el-radio label="50">Roughly equal (50/50 split)</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>

            <div v-if="sectionThreeForm.businessOperation && sectionThreeForm.businessOperation !== 'Brick-and Mortar Store (physical storefront, customers visit in person)'">
              <el-form-item label="Where do you store your inventory or products?" required prop="storeInventory">
                <el-radio-group v-model="sectionThreeForm.storeInventory">
                  <el-radio label="atHome">At Home</el-radio>
                  <el-radio label="separate">At a separate storage facility</el-radio>
                  <el-radio label="dropship">Drop shipping (supplier ships direct to customer)</el-radio>
                  <el-radio label="no">I don't hold physical inventory (Digital products or services only)
                  </el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item v-if="sectionThreeForm.storeInventory === 'atHome'">
                <el-checkbox class="checkbox-block" v-model="sectionThreeForm.storageSameAsAddress">Same as registered/trading address
                </el-checkbox>
              </el-form-item>

              <el-form-item v-if="sectionThreeForm.storeInventory === 'separate'" label="Storage Facility Address"
                            required prop="storageFacilityAddress">
                <el-input v-model="sectionThreeForm.storageFacilityAddress" type="textarea" :rows="2"></el-input>
              </el-form-item>
            </div>

            <el-form-item label="Expected Volume of Transactions (Per Annum)" required prop="expected_volume">
              <el-radio-group v-model="sectionThreeForm.expected_volume">
                <el-radio label="level1">0 - 500</el-radio>
                <el-radio label="level2">500 - 1000</el-radio>
                <el-radio label="level3">1000 - 2000</el-radio>
                <el-radio label="level4">> 5000</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="Expected Value of Transactions (Per Annum)" required prop="expected_value">
              <el-radio-group v-model="sectionThreeForm.expected_value">
                <el-radio label="level1">&lt; 100,000</el-radio>
                <el-radio label="level2">100,000 > 500,000</el-radio>
                <el-radio label="level3">500,000 > 5M</el-radio>
                <el-radio label="level4">5M > 10M</el-radio>
                <el-radio label="level5">> 10M</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-row style="margin-top: 20px;">
              <el-col :span="12">
                <el-button @click="onBackPageTwo">Back</el-button>
              </el-col>
              <el-col :span="12" style="text-align: right;">
                <el-button type="primary" @click="onToPageFour">Next</el-button>
              </el-col>
            </el-row>

          </el-form>

        </div>
        <div
            v-show="activePage === '4' || activeSection === 'section4'">

          <h2 class="section-title text-lg font-medium text-gray-900 border-b pb-2" style="text-align: left">Section 4 : Account
            Setup</h2>
          <el-form :model="sectionFourForm" label-position="top" style="text-align: left"
                   ref="sectionFourFormRef" :rules="sectionFourFormRules" id="sectionFourForm">

            <h2 class="text-lg font-semibold mb-2">Account Administrator Login Details</h2>
            <p class="text-sm text-gray-600 mb-4">
              (Please ensure that the email address for the account administrator is entered accurately, as this
              information
              cannot be changed after setup. For security and operational purposes, we will only accept formal
              instructions
              (e.g., changing bank account details, adding users, etc.) from this registered email address.)
            </p>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="Name" required prop="name">
                  <el-input v-model="sectionFourForm.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Email" required prop="email">
                  <el-input v-model="sectionFourForm.email" placeholder="example@example.com"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="Phone Number" required prop="phone">
                  <el-input
                      v-model="sectionFourForm.phone"
                      v-if="this.activeSection !== 'thankyou'"
                      style="max-width: 600px"
                      placeholder="Please input phone number"
                      class="input-with-select"
                  >
                    <template #prepend>
                      <el-select v-model="sectionFourForm.phoneCountryCode" placeholder="Country Dial"
                                 filterable
                                 style="width: 150px;background-color: var(--el-fill-color-blank);">
                        <el-option label="Australia(+61)" value="+61"></el-option>
                        <el-option label="New Zealand(+64)" value="+64"></el-option>
                        <el-option label="Hong Kong(+852)" value="+852"></el-option>
                        <el-option label="China(+86)" value="+86"></el-option>
                        <el-option label="United States(+1)" value="+1"></el-option>
                        <el-option label="Canada(+1)" value="+1"></el-option>
                        <el-option label="Singapore(+65)" value="+65"></el-option>
                        <el-option label="United Kingdom(+44)" value="+44"></el-option>
                      </el-select>
                    </template>
                  </el-input>


                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Position" required prop="position">
                  <el-input v-model="sectionFourForm.position"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <h2 class="text-lg font-semibold mt-6 mb-2">Settlement Bank Details</h2>
            <p class="text-sm text-gray-600 mb-4">
              *You are required to provide us the first page of your bank statement showing the bank name, account name,
              and account number. The account name must match your registered business name.
            </p>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="Bank" required prop="bank">
                  <el-input v-model="sectionFourForm.bank"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="SWIFT Code" prop="swiftCode">
                  <el-input v-model="sectionFourForm.swiftCode"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="Bank Account Name" required prop="bankAccountName">
                  <el-input v-model="sectionFourForm.bankAccountName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Bank Account Number" required prop="bankAccountNumber">
                  <el-input v-model="sectionFourForm.bankAccountNumber"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row style="margin-top: 50px;">
              <el-col :span="12">
                <el-button @click="onBackPageThree">Back</el-button>
              </el-col>
              <el-col :span="12" style="text-align: right;">
                <el-button type="primary" @click="onToPageFive">Next</el-button>
              </el-col>
            </el-row>


          </el-form>


        </div>

        <div v-show="activePage === '5' || activeSection === 'section5' || activeSection === 'section6'">
          <el-form :model="sectionFiveSixForm" label-position="top" style="text-align: left"
                   ref="sectionFiveSixFormRef" :rules="sectionFiveSixFormRules" id="sectionFiveSixForm">

            <h2 class="section-title text-lg font-medium text-gray-900 border-b pb-2" style="text-align: left">Section 5 : Know Your
              Customer (KYC) Documentation</h2>

<!--            v-if="sectionFiveSixForm.hasNomineeShareholders === 'yes'"-->

            <div >

              <div style="text-align: left">



<!--                Please note that as part of our regulatory requirements, we are obligated to identify the beneficial-->
<!--                owners, directors, and key details of your business.-->

                As a regulated payment service provider, we're required under AML/CFT Act to <strong>verify the identity of directors and beneficial owners.</strong>
                <br/>
                <br/>
                Please note: in addition to <strong>company details</strong>, we'll also <strong>require director and shareholder information</strong>
                <br/>
                — including <strong>ID and Proof of Address for those holding 25% or more.</strong>
<!--                <br/>-->
<!--                <br/>-->
<!--                Besides your <strong>company details</strong>, we require <strong>Identification Documents</strong>,-->
<!--                <strong>Proof of Address</strong> for <strong>all directors and shareholders who hold 25% and-->
<!--                more.</strong>-->
              </div>

<!--              <div style="text-align: left; margin-top: 20px;">-->
<!--                <p class="text-sm text-gray-600 mb-4">-->
<!--                  As a regulated payment service provider, we're required under AML/CFT law to verify the identity of-->
<!--                  your company's directors and beneficial owners (25%+ shareholders). This helps us keep your account-->
<!--                  secure and ensures your business can be onboarded smoothly.-->
<!--                </p>-->
<!--              </div>-->

              <h2 class="text-lg font-semibold mt-6 mb-2">Director / Shareholder Details</h2>

              <div v-for="(director, index) in sectionFiveSixForm.directors" :key="index"
                   class="director-card">
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <h3 class="text-base font-medium">Director / Shareholder {{ index + 1 }}</h3>
                <el-button v-if="sectionFiveSixForm.directors.length > 1" type="danger" link
                           @click="removeDirector(index)">Remove
                </el-button>
              </div>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="First Name" required :prop="'directors.' + index + '.firstName'"
                                :rules="[{required: true, message: 'First Name is required', trigger: 'blur'}]">
                    <el-input v-model="director.firstName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Last Name" required :prop="'directors.' + index + '.lastName'"
                                :rules="[{required: true, message: 'Last Name is required', trigger: 'blur'}]">
                    <el-input v-model="director.lastName"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="Date of Birth" required :prop="'directors.' + index + '.dob'"
                                :rules="[{required: true, message: 'Date of Birth is required', trigger: 'change'}]">
                    <el-date-picker v-model="director.dob" style="width: 100%" type="date"
                                    value-format="YYYY-MM-DD" placeholder="Select date"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="ID Type" required :prop="'directors.' + index + '.idType'"
                                :rules="[{required: true, message: 'ID Type is required', trigger: 'change'}]">
                    <el-select v-model="director.idType" placeholder="Please Select" style="width: 100%">
                      <el-option label="Driver License" value="DRIVER_LICENSE"></el-option>
                      <el-option label="Passport" value="PASSPORT"></el-option>
                      <el-option label="National ID" value="NATIONAL_ID"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="ID Issuing Country" required :prop="'directors.' + index + '.idCountry'"
                                :rules="[{required: true, message: 'ID Issuing Country is required', trigger: 'change'}]">
                    <el-select v-model="director.idCountry" placeholder="Select Country" filterable style="width: 100%">
                      <el-option
                          v-for="country in countryOptions"
                          :key="country.Code"
                          :label="country.Name"
                          :value="country.Code"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="ID Number" required :prop="'directors.' + index + '.idNumber'"
                                :rules="[{required: true, message: 'ID Number is required', trigger: 'blur'}]">
                    <el-input v-model="director.idNumber"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="ID Expiry Date" required :prop="'directors.' + index + '.idExpiryDate'"
                                :rules="[{required: true, message: 'ID Expiry Date is required', trigger: 'change'}]">
                    <el-date-picker v-model="director.idExpiryDate" style="width: 100%" type="date"
                                    value-format="YYYY-MM-DD" placeholder="Select date"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="director.idType === 'PASSPORT' && director.idCountry === 'CN'">
                  <el-form-item label="National ID" required
                                :prop="'directors.' + index + '.nationalIdNumber'"
                                :rules="[{required: true, message: 'National ID Number is required for China passport holders', trigger: 'blur'}]">
                    <el-input v-model="director.nationalIdNumber"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item label="Role" required :prop="'directors.' + index + '.role'"
                            :rules="[{required: true, message: 'Role is required', trigger: 'change'}]">
                <el-radio-group v-model="director.role">
                  <el-radio label="DIRECTOR">Director</el-radio>
                  <el-radio label="SHAREHOLDER">Shareholder</el-radio>
                  <el-radio label="BOTH">Both</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-row :gutter="20" v-if="director.role === 'SHAREHOLDER' || director.role === 'BOTH'">
                <el-col :span="12">
                  <el-form-item label="% Shareholding" required :prop="'directors.' + index + '.shareholding'"
                                :rules="shareholdingRules(index)">
                    <el-input v-model="director.shareholding" type="number" min="0" :max="maxShareholdingFor(index)">
                      <template #append>%</template>
                    </el-input>
                    <span style="color: #909399; font-size: 12px; line-height: 1.4;">
                      Max you can enter here: {{ maxShareholdingFor(index) }}% (remaining of 100%).
                    </span>
                    <span v-if="director.shareholding !== '' && Number(director.shareholding) < 25"
                          style="color: #e6a23c; font-size: 12px; line-height: 1.4;">
                      We only require shareholders holding 25% or more. Holdings below 25% will be discarded.
                    </span>
                  </el-form-item>
                </el-col>
              </el-row>
              </div>

              <el-form-item>
                <el-button type="primary" plain :disabled="!canAddDirector" @click="addDirector">
                  + Add another Director / Shareholder
                </el-button>
                <span v-if="!canAddDirector" class="text-sm text-gray-600" style="margin-left: 12px;">
                  Maximum reached — up to 4 directors and 4 shareholders (shareholding totalling 100%).
                </span>
                <span v-else-if="shareholdingTotal >= 100" class="text-sm text-gray-600" style="margin-left: 12px;">
                  Shareholding already totals 100% — you can still add directors, but not more shareholders.
                </span>
              </el-form-item>

            </div>

            <el-form-item label="Do you have any nominee directors and/or nominee shareholders?" required
                          prop="hasNomineeShareholders">
              <el-radio-group v-model="sectionFiveSixForm.hasNomineeShareholders">
                <el-radio label="yes">Yes</el-radio>
                <el-radio label="no">No</el-radio>
              </el-radio-group>
            </el-form-item>

             <div v-if="sectionFiveSixForm.hasNomineeShareholders === 'yes'">

               <h2 class="text-lg font-semibold mt-6 mb-2">Nominee Director / Shareholder</h2>
               <p class="text-sm text-gray-600 mb-4">
                 Please provide the details of the nominee director / nominee shareholder.
               </p>

               <div class="director-card">
                 <el-row :gutter="20">
                   <el-col :span="12">
                     <el-form-item label="First Name" required prop="nomineeDirector.firstName"
                                   :rules="[{required: true, message: 'First Name is required', trigger: 'blur'}]">
                       <el-input v-model="sectionFiveSixForm.nomineeDirector.firstName"></el-input>
                     </el-form-item>
                   </el-col>
                   <el-col :span="12">
                     <el-form-item label="Last Name" required prop="nomineeDirector.lastName"
                                   :rules="[{required: true, message: 'Last Name is required', trigger: 'blur'}]">
                       <el-input v-model="sectionFiveSixForm.nomineeDirector.lastName"></el-input>
                     </el-form-item>
                   </el-col>
                 </el-row>

                 <el-row :gutter="20">
                   <el-col :span="12">
                     <el-form-item label="Date of Birth" required prop="nomineeDirector.dob"
                                   :rules="[{required: true, message: 'Date of Birth is required', trigger: 'change'}]">
                       <el-date-picker v-model="sectionFiveSixForm.nomineeDirector.dob" style="width: 100%" type="date"
                                       value-format="YYYY-MM-DD" placeholder="Select date"></el-date-picker>
                     </el-form-item>
                   </el-col>
                   <el-col :span="12">
                     <el-form-item label="ID Type" required prop="nomineeDirector.idType"
                                   :rules="[{required: true, message: 'ID Type is required', trigger: 'change'}]">
                       <el-select v-model="sectionFiveSixForm.nomineeDirector.idType" placeholder="Please Select" style="width: 100%">
                         <el-option label="Driver License" value="DRIVER_LICENSE"></el-option>
                         <el-option label="Passport" value="PASSPORT"></el-option>
                         <el-option label="National ID" value="NATIONAL_ID"></el-option>
                       </el-select>
                     </el-form-item>
                   </el-col>
                 </el-row>

                 <el-row :gutter="20">
                   <el-col :span="12">
                     <el-form-item label="ID Issuing Country" required prop="nomineeDirector.idCountry"
                                   :rules="[{required: true, message: 'ID Issuing Country is required', trigger: 'change'}]">
                       <el-select v-model="sectionFiveSixForm.nomineeDirector.idCountry" placeholder="Select Country" filterable style="width: 100%">
                         <el-option
                             v-for="country in countryOptions"
                             :key="country.Code"
                             :label="country.Name"
                             :value="country.Code"
                         ></el-option>
                       </el-select>
                     </el-form-item>
                   </el-col>
                   <el-col :span="12">
                     <el-form-item label="ID Number" required prop="nomineeDirector.idNumber"
                                   :rules="[{required: true, message: 'ID Number is required', trigger: 'blur'}]">
                       <el-input v-model="sectionFiveSixForm.nomineeDirector.idNumber"></el-input>
                     </el-form-item>
                   </el-col>
                 </el-row>

                 <el-row :gutter="20">
                   <el-col :span="12">
                     <el-form-item label="ID Expiry Date" required prop="nomineeDirector.idExpiryDate"
                                   :rules="[{required: true, message: 'ID Expiry Date is required', trigger: 'change'}]">
                       <el-date-picker v-model="sectionFiveSixForm.nomineeDirector.idExpiryDate" style="width: 100%" type="date"
                                       value-format="YYYY-MM-DD" placeholder="Select date"></el-date-picker>
                     </el-form-item>
                   </el-col>
                   <el-col :span="12" v-if="sectionFiveSixForm.nomineeDirector.idType === 'PASSPORT' && sectionFiveSixForm.nomineeDirector.idCountry === 'CN'">
                     <el-form-item label="National ID" required
                                   prop="nomineeDirector.nationalIdNumber"
                                   :rules="[{required: true, message: 'National ID Number is required for China passport holders', trigger: 'blur'}]">
                       <el-input v-model="sectionFiveSixForm.nomineeDirector.nationalIdNumber"></el-input>
                     </el-form-item>
                   </el-col>
                 </el-row>
               </div>

             </div>
            <h2 class="section-title text-xl font-semibold mt-8 mb-4">Section 6 : Declarations and Authorizations</h2>

            <el-form-item required prop="declaration1">
              <el-checkbox class="checkbox-block" v-model="sectionFiveSixForm.declaration1"><span class="checkbox-text">1. I/We confirm that all provided information
                is accurate and complete.</span>
              </el-checkbox>
            </el-form-item>
            <el-form-item required prop="declaration2">
              <el-checkbox class="checkbox-block" v-model="sectionFiveSixForm.declaration2"><span class="checkbox-text">2. Latipay reserves the right to request
                additional documents or information as may deemed to be necessary.</span>
              </el-checkbox>
            </el-form-item>
            <el-form-item required prop="declaration3">
              <el-checkbox class="checkbox-block" v-model="sectionFiveSixForm.declaration3"><span class="checkbox-text">3. Latipay reserves the exclusive authority to
                either approve or decline the application as its sole discretion.</span>
              </el-checkbox>
            </el-form-item>
            <el-form-item required prop="declaration4">
              <el-checkbox class="checkbox-block" v-model="sectionFiveSixForm.declaration4" style="margin-top: 20px">
                <span class="checkbox-text">
                4. I/We agree with the
                <el-link
                    v-if="!form.countryOfIncorporation || form.countryOfIncorporation === 'NZ' || form.countryOfIncorporation === 'OTHER'"
                    target="_blank" type="primary" href="https://document.latipay.net/Latipay_NZ_General_T&C.pdf">Terms &
                  Condition
                </el-link>
                  <el-link v-if="form.countryOfIncorporation === 'AU'" target="_blank" type="primary"
                           href="https://document.latipay.net/LATIPAY_AU_General_T&C.pdf">Terms &
                  Condition
                </el-link>
                  <el-link v-if="form.countryOfIncorporation === 'HK'" target="_blank" type="primary"
                           href="https://document.latipay.net/LPHK_Terms_and_Conditions_0723.pdf">Terms &
                  Condition
                </el-link>
                  <span v-if="form.countryOfIncorporation !== 'HK'"> & </span>

                    <el-link
                        v-if="!form.countryOfIncorporation || form.countryOfIncorporation === 'NZ' || form.countryOfIncorporation === 'OTHER'"
                        target="_blank" type="primary"
                        href="https://document.latipay.net/LATIPAY_NZ_Privacy_Policy.pdf">Privacy Policy
                </el-link>
                  <el-link v-if="form.countryOfIncorporation === 'AU'" target="_blank" type="primary"
                           href="https://document.latipay.net/LATIPAY_AU_Privacy_Policy.pdf">Privacy Policy
                </el-link>
                  <!--                  <el-link v-if="form.countryOfIncorporation === 'HK'" target="_blank" type="primary" href="https://document.latipay.net/LPHK_Terms_and_Conditions_0723.pdf">Privacy Policy-->
                  <!--                </el-link>-->
                and I am authorised to provide identity documentation and I consent to this information being checked
                with third party verification partners, which include verification by the document issuer, authorised
                record holder, telecommunications service provider, or credit reporting agency, for the purpose of
                identity verification.
                </span>
              </el-checkbox>
            </el-form-item>
            <el-row style="margin-top: 50px;">
              <el-col :span="12">
                <el-button @click="onBackPageFour">Back</el-button>
              </el-col>
              <el-col :span="12" style="text-align: right;">
                <el-button type="primary" @click="onSubmit">Submit</el-button>
              </el-col>
            </el-row>
          </el-form>


        </div>

        <div v-if="this.activePage === 'thankyou'">
          <img class="h-12 w-auto mx-auto" :src="greenTick" alt="" style="width: 80px;margin-top: 50px">
          <h1 class="text-4xl font-bold text-gray-800 mb-4">Thank You!</h1>
          <p class="text-gray-600 text-lg">Thank you for your interest in Latipay.<br/><br/>

            To move forward, we will provide you with a guide outlining what to prepare and submit to complete our verification and underwriting process.<br/><br/>
            Please ensure to check the email address provided during registration, including the inbox & junk/spam folder, for the guideline. If you have any questions, feel free to reach to us via customerservice@latipay.net<br/><br/>
            We look forward to assisting you further.

          </p>


        </div>

      </el-card>


    </div>

  </div>


</template>

<script>
import {computed, ref} from "vue";
import latipayLogo from '@/assets/lp-logo.png';
import pmLogo from '@/assets/pm.png';
import greenTick from '@/assets/tick.png';
import countryData from '@/assets/code-table/countries-iso.json';
import dialData from '@/assets/code-table/countries-dial-code.json';
import {ElMessage} from "element-plus";
import {InfoFilled} from "@element-plus/icons-vue";
import {toRaw} from 'vue';
import {debounce} from 'lodash';
import axios from "axios";


export default {
  name: 'HelloWorld',
  components: {
    InfoFilled
  },
  props: {
    msg: String
  },
  data() {
    return {
      isMobile: typeof window !== 'undefined' && window.innerWidth <= 768
    };
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth <= 768;
    },
    fillMockData() {
      Object.assign(this.form, {
        legalBusinessName: 'Test Trading Co Ltd',
        tradingName: 'Test Trading Co',
        countryOfIncorporation: 'NZ',
        companyRegistrationNumber: '1234567',
        dateOfIncorporation: '2020-01-01',
        businessType: 'LIMITED_COMPANY',
        sameAddress: true,
        tradingAddressResidential: false,
        businessPhone: '211234567',
        businessPhoneCountryCode: 'NZ',
        businessEmail: 'test@example.com',
      });
      Object.assign(this.form.registeredAddress, {
        street: '1 Test Street', city: 'Auckland', state: 'Auckland', postalCode: '1010', country: 'NZ'
      });
      Object.assign(this.form.contactPerson, {
        firstName: 'John', lastName: 'Doe', email: 'john@example.com', phone: '211234567',
        phoneCountryCode: 'NZ', position: 'Director'
      });

      Object.assign(this.sectionTwoForm, {
        currency: 'NZD',
        annualCardTurnover: '100000',
        avgMonthlyTransactionValue: '5000',
        deliveryTimeframe: '3-5 days',
        estMonthlyChargebackValue: '100',
        estMonthlyRefundsValue: '100',
        disputeTiming: '0-14',
      });
      this.sectionTwoForm.onlinePayments.vm = true;
      this.sectionTwoForm.offlinePayments.polipay = true;

      Object.assign(this.sectionThreeForm, {
        businessCategory: 'Retail Trade',
        businessOperation: 'Brick-and Mortar Store (physical storefront, customers visit in person)',
        bm_hasWebsite: 'no',
        bm_productsServices: 'General retail goods',
        storeInventory: 'atHome',
        storageSameAsAddress: true,
        expected_volume: 'level1',
        expected_value: 'level1',
      });

      Object.assign(this.sectionFourForm, {
        name: 'John Doe',
        email: 'john@example.com',
        phone: '211234567',
        phoneCountryCode: 'NZ',
        position: 'Director',
        bank: 'Test Bank',
        swiftCode: 'TESTNZ2A',
        bankAccountName: 'Test Trading Co Ltd',
        bankAccountNumber: '00-0000-0000000-00',
      });

      Object.assign(this.sectionFiveSixForm.directors[0], {
        firstName: 'John', lastName: 'Doe', dob: '1980-01-01', idType: 'PASSPORT', idCountry: 'NZ', idNumber: 'P1234567',
        idExpiryDate: '2030-01-01', nationalIdNumber: '', role: 'BOTH', shareholding: '100'
      });
      this.sectionFiveSixForm.hasNomineeShareholders = 'yes';
      Object.assign(this.sectionFiveSixForm.nomineeDirector, {
        firstName: 'Jane', lastName: 'Nominee', dob: '1985-05-05', idType: 'PASSPORT', idCountry: 'CN', idNumber: 'N7654321',
        idExpiryDate: '2031-01-01', nationalIdNumber: 'CN000111'
      });
      Object.assign(this.sectionFiveSixForm, {
        declaration1: true, declaration2: true, declaration3: true, declaration4: true
      });

      ElMessage({message: 'Mock data filled in — review each section, then Submit.', type: 'success'});
    },
    debouncedFilter: debounce(function (query) {
      this.filter(query);
    }, 300),
    filter(query) {
      // Perform filtering logic
      console.log(query);
    },

    handleTabClick(item) {
      // Handle the click action
      console.log(item)
      this.activeSection = item.props.name
      if (this.activeSection === 'section1') {
        this.activePage = '1'
      } else if (this.activeSection === 'section2') {
        this.activePage = '2'
      } else if (this.activeSection === 'section3') {
        this.activePage = '3'
      } else if (this.activeSection === 'section4') {
        this.activePage = '4'
      } else {
        this.activePage = '5'
      }
      console.log('Clicked tab:', this.activeSection);


      // You can add any logic here, like opening a modal, navigating, etc.
    },
    onToPageTwo() {

      console.log('step one Form submitted:', this.form)
      if (this.$refs.formRef) {
        this.$refs.formRef.validate(async (valid) => {
          if (valid) {
            console.log("Validation successful. Proceeding to Section 2.");


            this.activeSection = "section2";
            this.activePage = "2";
          } else {
            console.log("Validation failed. Remaining on current page.");
          }
        });
      } else {
        console.error("Form reference is not defined!");
      }

    },
    onToPageThree() {
      console.log('Form submitted:')

      if (this.$refs.sectionTwoFormRef) {
        this.$refs.sectionTwoFormRef.validate((valid) => {
          if (valid) {
            console.log("Validation successful. Proceeding to Section 3.");

            // Check if any payment method is selected
            if (!this.sectionTwoForm.onlinePayments.vm &&
                !this.sectionTwoForm.onlinePayments.polipay &&
                !this.sectionTwoForm.onlinePayments.wechat &&
                !this.sectionTwoForm.onlinePayments.alipay &&
                !this.sectionTwoForm.onlinePayments.payID &&
                !this.sectionTwoForm.onlinePayments.unionpay &&
                !this.sectionTwoForm.offlinePayments.polipay &&
                !this.sectionTwoForm.offlinePayments.wechat &&
                !this.sectionTwoForm.offlinePayments.alipayPlus &&
                !this.sectionTwoForm.offlinePayments.payID &&
                !this.sectionTwoForm.offlinePayments.unionpay) {
              ElMessage({
                message: 'Please select at least one payment method',
                type: 'warning',
              });
            } else {
              // Proceed to next section
              this.activeSection = 'section3';
              this.activePage = '3';
            }
          } else {
            console.log("Validation failed");
          }
        });
      } else {
        console.error("Form reference is not defined!");
      }

    },
    onToPageFour() {


      if (this.$refs.sectionThreeFormRef) {
        this.$refs.sectionThreeFormRef.validate((valid) => {
          if (valid) {
            console.log("Validation successful. Proceeding to Section 4.");
            this.activeSection = 'section4'
            this.activePage = '4'
          } else {
            console.log("Validation failed. Remaining on current page.");
          }
        });
      } else {
        console.error("Form reference is not defined!");
      }
    },
    onToPageFive() {


      if (this.$refs.sectionFourFormRef) {
        this.$refs.sectionFourFormRef.validate((valid) => {
          if (valid) {
            console.log("Validation successful. Proceeding to Section 4.");
            this.activeSection = 'section5'
            this.activePage = '5'
          } else {
            console.log("Validation failed. Remaining on current page.");
          }
        });
      } else {
        console.error("Form reference is not defined!");
      }
    },
    onBackPageOne() {
      this.activePage = '1'
      this.activeSection = 'section1'
      console.log('back')
    },
    onBackPageTwo() {
      this.activePage = '2'
      this.activeSection = 'section2'
      console.log('back')
    },
    onBackPageThree() {
      this.activePage = '3'
      this.activeSection = 'section3'
      console.log('back')
    },

    onBackPageFour() {
      this.activePage = '4'
      this.activeSection = 'section4'
      console.log('back')
    },
    formatFieldName(key) {
      // Convert camelCase to Title Case
      return key
          .replace(/([A-Z])/g, ' $1')
          .replace(/^./, str => str.toUpperCase());
    },
    addDirector() {
      if (!this.canAddDirector) return;
      this.sectionFiveSixForm.directors.push({
        firstName: '',
        lastName: '',
        dob: '',
        idType: '',
        idCountry: '',
        idNumber: '',
        idExpiryDate: '',
        nationalIdNumber: '',
        role: '',
        shareholding: ''
      });
    },
    removeDirector(index) {
      if (this.sectionFiveSixForm.directors.length <= 1) return;
      this.sectionFiveSixForm.directors.splice(index, 1);
    },
    // Max % this shareholder may hold = 100 minus the sum held by the others
    maxShareholdingFor(index) {
      const directors = this.sectionFiveSixForm.directors || [];
      const othersTotal = directors.reduce((sum, d, i) => {
        if (i === index) return sum;
        if (d.role !== 'SHAREHOLDER' && d.role !== 'BOTH') return sum;
        return sum + (Number(d.shareholding) || 0);
      }, 0);
      return Math.max(0, 100 - othersTotal);
    },
    // Per-field validation rules for a shareholding input
    shareholdingRules(index) {
      return [
        {required: true, message: '% Shareholding is required', trigger: 'blur'},
        {
          validator: (rule, value, callback) => {
            if (value === '' || value === null) {
              callback();
              return;
            }
            const v = Number(value);
            if (isNaN(v) || v < 0 || v > 100) {
              callback(new Error('Shareholding must be between 0 and 100'));
              return;
            }
            if (v > this.maxShareholdingFor(index)) {
              callback(new Error('Total shareholding across all shareholders cannot exceed 100%'));
              return;
            }
            callback();
          },
          trigger: 'blur'
        }
      ];
    },
    async onSubmit() {
      if (this.form && this.sectionTwoForm && this.sectionThreeForm && this.sectionFourForm && this.sectionFiveSixFormRef) {
        try {
          // Await form validations
          const isFormOneValid = await this.$refs.formRef.validate();
          const isFormTwoValid = await this.$refs.sectionTwoFormRef.validate();
          const isFormThreeValid = await this.$refs.sectionThreeFormRef.validate();
          const isFormFourValid = await this.$refs.sectionFourFormRef.validate();
          const isFormFiveSixValid = await this.$refs.sectionFiveSixFormRef.validate(); // Switch to promise-based validation

          // Check if all validations and declarations are valid
          if (isFormOneValid && isFormTwoValid && isFormThreeValid && isFormFourValid && isFormFiveSixValid
              && this.sectionFiveSixForm.declaration1 && this.sectionFiveSixForm.declaration2
              && this.sectionFiveSixForm.declaration3 && this.sectionFiveSixForm.declaration4) {

            console.log("Validation successful. Proceeding to Section 4.");

            // Prepare merged forms
            const mergedForms = computed(() => ({
              section1: {
                name: 'Section 1 - Business Information',
                data: toRaw(this.form),
              },
              section2: {
                name: 'Section 2 - Payment Methods',
                data: toRaw(this.sectionTwoForm),
              },
              section3: {
                name: 'Section 3 - Business Operations',
                data: toRaw(this.sectionThreeForm),
              },
              section4: {
                name: 'Section 4 - Account Setup',
                data: toRaw(this.sectionFourForm),
              },
              section5And6: {
                name: 'Section 5&6 - KYC & Declarations and Authorizations',
                data: toRaw(this.sectionFiveSixForm),
              },
            }));

            // Log merged form data
            console.log(mergedForms.value);
            this.loading = true

            // Make API request https://merchant-onboarding-api-staging.latipay.net/v1/merchant-onboard

            const response = await axios.post('https://merchant-onboarding-api.latipay.net/v1/merchant-onboard', mergedForms.value, {
              headers: {
                'Content-Type': 'application/json',
              },
            });

            // Check if the response status is 200
            if (response.status === 200) {
              console.log('Response:', response.data);
              this.loading = false
              // Reset form fields
              this.form = {
                //section1
                legalBusinessName: '',
                tradingName: '',
                countryOfIncorporation: '',
                countryOfIncorporationOther: '',
                companyRegistrationNumber: '',
                dateOfIncorporation: '',
                businessType: '',
                businessTypeOther: '',
                registeredAddress: {
                  street: '',
                  street2: '',
                  city: '',
                  state: '',
                  postalCode: '',
                  country: ''
                },
                operationalAddress: {
                  street: '',
                  street2: '',
                  city: '',
                  state: '',
                  postalCode: '',
                  country: ''
                },
                sameAddress: false,
                tradingAddressResidential: false,
                businessPhone: '',
                businessPhoneCountryCode: '',
                businessEmail: '',
                contactPerson: {
                  firstName: '',
                  middleName: '',
                  lastName: '',
                  phone: '',
                  phoneCountryCode: '',
                  email: '',
                  position: ''
                }
              }

              this.sectionTwoForm = {

                //section2
                products: '',
                markets: '',
                channels: '',
                acquirer: '',
                chargeback: '',
                currency: '',
                annualCardTurnover: '',
                avgMonthlyTransactionValue: '',
                deliveryTimeframe: '',
                estMonthlyChargebackValue: '',
                estMonthlyRefundsValue: '',
                disputeTiming: '',
                onlinePayments: {
                  vm: false,
                  polipay: false,
                  wechat: false,
                  alipay: false,
                  payID: false,
                  unionpay: false
                },
                offlinePayments: {
                  polipay: false,
                  wechat: false,
                  alipayPlus: false,
                  payID: false
                }
              }

              this.sectionThreeForm = {
                businessCategory: '',
                businessOperation: '',
                //Brick and Mortar Store
                bm_productsServices: '',
                bm_hasWebsite: '',
                bm_websiteLink: '',
                //Hom Based Business
                hb_productsServices: '',
                hb_vistHome: '',
                hb_hasWebsite: '',
                hb_websiteLink: '',
                //Online Only Business
                ob_productsServices: '',
                ob_websiteLink: '',
                ob_platform: '',
                ob_platform_other: '',
                ob_international: '',
                //Mixed
                mix_productsServices: '',
                mix_websiteLink: '',
                mix_salesFrom: '',
                //Inventory storage (shared across all operation types)
                storeInventory: '',
                storageSameAsAddress: false,
                storageFacilityAddress: '',
                expected_volume: '',
                expected_value: ''
              }

              this.sectionFourForm = {
                name: '',
                email: '',
                phone: '',
                phoneCountryCode: '',
                position: '',
                bank: '',
                swiftCode: '',
                bankAccountName: '',
                bankAccountNumber: '',
              }

              this.sectionFiveSixForm = {
                hasNomineeShareholders: null,
                directors: [
                  {
                    firstName: '',
                    lastName: '',
                    dob: '',
                    idType: '',
                    idCountry: '',
                    idNumber: '',
                    idExpiryDate: '',
                    nationalIdNumber: '',
                    role: '',
                    shareholding: ''
                  }
                ],
                nomineeDirector: {
                  firstName: '',
                  lastName: '',
                  dob: '',
                  idType: '',
                  idCountry: '',
                  idNumber: '',
                  idExpiryDate: '',
                  nationalIdNumber: ''
                },
                declaration1: false,
                declaration2: false,
                declaration3: false,
                declaration4: false
              }


              // Navigate to thank you page
              this.activePage = 'thankyou';
              this.activeSection = 'thankyou';
            } else {
              ElMessage({
                message: 'Failed to submit the onboarding application form. Please try again later.',
                type: 'error',
              });
            }
          } else {
            this.loading = false
            console.log("Validation failed. Remaining on current page.");
            ElMessage({
              message: 'Please confirm and agree with the declarations and authorizations',
              type: 'warning',
            });
          }
        } catch (error) {
          this.loading = false
          // Log detailed error response
          if (error.response) {
            console.error('Error response:', JSON.stringify(error.response.data, null, 2));  // Log error details
          } else {
            console.error('Error message:', error.message);  // Log general error message
          }

          ElMessage({
            message: 'Failed to submit the onboarding application form. Please try again later.',
            type: 'error',
          });
        }
      } else {
        this.loading = false
        ElMessage({
          message: 'Please confirm and agree with the declarations and authorizations',
          type: 'warning',
        });

        console.error("Please complete all the required information!");
      }
    }

  },
  computed: {
    // Only show the test-data auto-fill button outside of production builds
    isDevMode() {
      return process.env.NODE_ENV !== 'production';
    },
    // Auto-populate local currency from Country of Incorporation (Section 1)
    localCurrency() {
      const map = {NZ: 'NZD', AU: 'AUD', HK: 'HKD'};
      return map[this.form.countryOfIncorporation] || '';
    },
    // Entries acting as a director (Director or Both)
    directorCount() {
      return (this.sectionFiveSixForm.directors || [])
          .filter(d => d.role === 'DIRECTOR' || d.role === 'BOTH').length;
    },
    // Entries acting as a shareholder (Shareholder or Both)
    shareholderCount() {
      return (this.sectionFiveSixForm.directors || [])
          .filter(d => d.role === 'SHAREHOLDER' || d.role === 'BOTH').length;
    },
    // Combined shareholding across all shareholders (Shareholder or Both)
    shareholdingTotal() {
      return (this.sectionFiveSixForm.directors || [])
          .filter(d => d.role === 'SHAREHOLDER' || d.role === 'BOTH')
          .reduce((sum, d) => sum + (Number(d.shareholding) || 0), 0);
    },
    // Add is allowed while there is room for another director (max 4),
    // OR room for another shareholder (max 4 AND total shareholding < 100%).
    // Reaching 100% shareholding must NOT block adding more directors.
    canAddDirector() {
      const directors = this.sectionFiveSixForm.directors || [];
      const roomForDirector = this.directorCount < 4;
      const roomForShareholder = this.shareholderCount < 4 && this.shareholdingTotal < 100;
      return (roomForDirector || roomForShareholder) && directors.length < 8;
    }
  },
  setup() {
    const activeSection = ref('section1')
    const activePage = '1'
    const categories = ['Retail Trade', 'Luxury Retail', 'Wholesale Trade', 'E-Commerce', 'Manufacturing', 'Food & Beverage', 'Healthcare', 'Leisure & Entertainment', 'Hospitality & Tourism',
      'Education & Training', 'Services', 'Transportation, Postal and Warehousing', 'Professional Services', 'Non-Profit - Charities, Social and Community Service']
    const operations = [
      'Brick-and Mortar Store (physical storefront, customers visit in person)',
      'Home-Based Business (Operates primarily from a residential address)',
      'Online-Only Business (No Physical storefront, operates entirely online)',
      'Mixed/Service-Based Business (Combines Physical, Online, or service-based operations)'
    ]
    const loading = ref(false)
    const formRef = ref(null)
    const form = ref({
      //section1
      legalBusinessName: '',
      tradingName: '',
      countryOfIncorporation: '',
      countryOfIncorporationOther: '',
      companyRegistrationNumber: '',
      dateOfIncorporation: '',
      businessType: '',
      businessTypeOther: '',
      registeredAddress: {
        street: '',
        street2: '',
        city: '',
        state: '',
        postalCode: '',
        country: ''
      },
      operationalAddress: {
        street: '',
        street2: '',
        city: '',
        state: '',
        postalCode: '',
        country: ''
      },
      sameAddress: false,
      tradingAddressResidential: false,
      businessPhone: '',
      businessPhoneCountryCode: '',
      businessEmail: '',
      contactPerson: {
        firstName: '',
        middleName: '',
        lastName: '',
        phone: '',
        phoneCountryCode: '',
        email: '',
        position: ''
      }

    })
    const formRules = ref({
      legalBusinessName: [{required: true, message: "Legal Business Name is required", trigger: "blur"}],
      tradingName: [{required: true, message: "Trading Name is required", trigger: "blur"}],
      countryOfIncorporation: [{required: true, message: "Country of Incorporation is required", trigger: "change"}],
      businessPhone: [{required: true, message: "Business Phone is required", trigger: "blur"}],
      businessPhoneCountryCode: [
        {required: true, message: "Country Dial is required", trigger: "blur"},
      ],
      companyRegistrationNumber: [{
        required: true,
        message: "Company Registration Number is required",
        trigger: "blur"
      }],
      dateOfIncorporation: [{required: true, message: "Date of Incorporation is required", trigger: "blur"}],
      businessType: [{required: true, message: "Business Type is required", trigger: "blur"}],
      "registeredAddress.street": [{required: true, message: "Street is required", trigger: "blur"}],
      "registeredAddress.city": [{required: true, message: "City is required", trigger: "blur"}],
      "registeredAddress.state": [{required: true, message: "State is required", trigger: "blur"}],
      "registeredAddress.postalCode": [{required: true, message: "Postal Code is required", trigger: "blur"}],
      "registeredAddress.country": [{required: true, message: "Country is required", trigger: "blur"}],
      "operationalAddress.street": [{required: true, message: "Street is required", trigger: "blur"}],
      "operationalAddress.city": [{required: true, message: "City is required", trigger: "blur"}],
      "operationalAddress.state": [{required: true, message: "State is required", trigger: "blur"}],
      "operationalAddress.postalCode": [{required: true, message: "Postal Code is required", trigger: "blur"}],
      "operationalAddress.country": [{required: true, message: "Country is required", trigger: "blur"}],
      businessEmail: [{required: true, message: "Business Name is required", trigger: "blur"},
        { type: 'email', message: 'Please input a valid email address', trigger: 'blur' }],
      "contactPerson.firstName": [{required: true, message: "Contact Person First Name is required", trigger: "blur"}],
      "contactPerson.lastName": [{required: true, message: "Contact Person Last Name is required", trigger: "blur"}],
      "contactPerson.phone": [{required: true, message: "Contact Person Phone is required", trigger: "blur"}],
      "contactPerson.position": [{required: true, message: "Contact Person Position is required", trigger: "blur"}],
      "contactPerson.email": [{required: true, message: "Contact Person Email is required", trigger: "blur"},
        { type: 'email', message: 'Please input a valid email address', trigger: 'blur' }],

    })


    const sectionTwoFormRef = ref(null)
    const sectionTwoForm = ref({

      //section2
      products: '',
      markets: '',
      channels: '',
      acquirer: '',
      chargeback: '',
      currency: '',
      annualCardTurnover: '',
      avgMonthlyTransactionValue: '',
      deliveryTimeframe: '',
      estMonthlyChargebackValue: '',
      estMonthlyRefundsValue: '',
      disputeTiming: '',
      onlinePayments: {
        vm: false,
        polipay: false,
        wechat: false,
        alipay: false,
        payID: false,
        unionpay: false
      },
      offlinePayments: {
        polipay: false,
        wechat: false,
        alipayPlus: false,
        payID: false
      }
    })
    const sectionTwoFormRules = ref({
      products: [{required: true, message: "Product/Services Provided is required", trigger: "blur"}],
      markets: [{required: true, message: "Target Markets is required", trigger: "blur"}],
      channels: [{required: true, message: "Advertising Channels is required", trigger: "change"}],
      acquirer: [{required: true, message: "Current Acquirer is required", trigger: "blur"}],
      chargeback: [
        {required: true, message: "Chargeback Rate is required", trigger: "blur"},
      ],
      annualCardTurnover: [{required: true, message: "Annual Card Turnover is required", trigger: "blur"}],
      avgMonthlyTransactionValue: [{required: true, message: "Average Ticket Size is required", trigger: "blur"}],
      deliveryTimeframe: [{required: true, message: "Delivery Timeframe is required", trigger: "blur"}],
      estMonthlyChargebackValue: [{required: true, message: "Chargeback Rate is required", trigger: "blur"}],
      estMonthlyRefundsValue: [{required: true, message: "Refund Rate is required", trigger: "blur"}],
      disputeTiming: [{required: true, message: "Dispute Timing is required", trigger: "change"}]

    })

    const sectionThreeFormRef = ref(null)
    const sectionThreeForm = ref({
      businessCategory: '',
      businessOperation: '',
      //Brick and Mortar Store
      bm_productsServices: '',
      bm_hasWebsite: '',
      bm_websiteLink: '',
      //Hom Based Business
      hb_productsServices: '',
      hb_vistHome: '',
      hb_hasWebsite: '',
      hb_websiteLink: '',
      //Online Only Business
      ob_productsServices: '',
      ob_websiteLink: '',
      ob_platform: '',
      ob_platform_other: '',
      ob_international: '',
      //Mixed
      mix_productsServices: '',
      mix_websiteLink: '',
      mix_salesFrom: '',
      //Inventory storage (shared across all operation types)
      storeInventory: '',
      storageSameAsAddress: false,
      storageFacilityAddress: '',
      expected_volume: '',
      expected_value: ''
    })
    const sectionThreeFormRules = ref({
      businessCategory: [{required: true, message: "Business Category is required", trigger: "blur"}],
      businessOperation: [{required: true, message: "Business Operation is required", trigger: "blur"}],
      bm_productsServices: [{required: true, message: "Products or services you offer is required", trigger: "change"}],

      bm_hasWebsite: [{required: true, message: "Please provide the answer", trigger: "change"}],
      bm_websiteLink: [{required: true, message: "Website or online link is required", trigger: "change"}],
      //Hom Based Business
      hb_productsServices: [{required: true, message: "Products or services you offer is required", trigger: "change"}],
      hb_vistHome: [{required: true, message: "Please provide the answer", trigger: "change"}],
      hb_hasWebsite: [{required: true, message: "Please provide the answer", trigger: "change"}],
      hb_websiteLink: [{required: true, message: "Website or online link is required", trigger: "change"}],
      //Online Only Business
      ob_productsServices: [{required: true, message: "Products or services you offer is required", trigger: "change"}],
      ob_websiteLink: [{required: true, message: "Website or online link is required", trigger: "change"}],
      ob_platform: [{required: true, message: "Please provide the answer", trigger: "change"}],
      ob_platform_other: [{required: true, message: "Please provide the answer", trigger: "change"}],
      ob_international: [{required: true, message: "Please provide the answer", trigger: "change"}],
      //Mixed
      mix_productsServices: [{
        required: true,
        message: "Products or services you offer is required",
        trigger: "change"
      }],
      mix_websiteLink: [{required: true, message: "Website or online link is required", trigger: "change"}],
      mix_salesFrom: [{required: true, message: "Please provide the answer", trigger: "change"}],

      storeInventory: [{required: true, message: "Please provide the answer", trigger: "change"}],
      storageFacilityAddress: [{required: true, message: "Storage Facility Address is required", trigger: "blur"}],
      expected_volume: [{required: true, message: "Expected Volume is required", trigger: "change"}],
      expected_value: [{required: true, message: "Expected Value is required", trigger: "change"}],

    })


    const sectionFourFormRef = ref(null)

    const sectionFourForm = ref({
      name: '',
      email: '',
      phone: '',
      phoneCountryCode: '',
      position: '',
      bank: '',
      swiftCode: '',
      bankAccountName: '',
      bankAccountNumber: '',
    })

    const sectionFourFormRules = ref({
      name: [{required: true, message: "Administrator Name is required", trigger: "blur"}],
      email: [{required: true, message: "Administrator Email is required", trigger: "blur"},
        { type: 'email', message: 'Please input a valid email address', trigger: 'blur' }],
      phone: [{required: true, message: "Administrator Phone is required", trigger: "blur"}],
      position: [{required: true, message: "Administrator Position is required", trigger: "blur"}],
      bank: [{required: true, message: "Bank Name is required", trigger: "blur"}],
      bankAccountName: [{required: true, message: "Bank Account Name is required", trigger: "blur"}],
      bankAccountNumber: [{required: true, message: "Bank Account Number is required", trigger: "blur"}],
    })

    const sectionFiveSixFormRef = ref(null)
    const sectionFiveSixForm = ref({
      hasNomineeShareholders: null,
      directors: [
        {
          firstName: '',
          lastName: '',
          dob: '',
          idType: '',
          idCountry: '',
          idNumber: '',
          idExpiryDate: '',
          nationalIdNumber: '',
          role: '',
          shareholding: ''
        }
      ],
      nomineeDirector: {
        firstName: '',
        lastName: '',
        dob: '',
        idType: '',
        idCountry: '',
        idNumber: '',
        idExpiryDate: '',
        nationalIdNumber: ''
      },
      declaration1: false,
      declaration2: false,
      declaration3: false,
      declaration4: false
    })

    const sectionFiveSixFormRules = ref({
      hasNomineeShareholders: [{required: true, message: "Please provide the answer", trigger: "blur"}],
      declaration1: [{required: true, message: "", trigger: "blur"}],
      declaration2: [{required: true, message: "", trigger: "blur"}],
      declaration3: [{required: true, message: "", trigger: "blur"}],
      declaration4: [{required: true, message: "", trigger: "blur"}]
    })

    const resetForm = () => {
      if (formRef.value) {
        formRef.value.resetFields(); // Reset the form fields
      }
    };


    return {
      form,
      sectionTwoForm,
      sectionThreeForm,
      sectionFourForm,
      sectionFiveSixForm,
      formRef,
      formRules,
      sectionTwoFormRef,
      sectionTwoFormRules,
      sectionThreeFormRef,
      sectionThreeFormRules,
      sectionFourFormRef,
      sectionFourFormRules,
      sectionFiveSixFormRef,
      sectionFiveSixFormRules,
      activePage,
      activeSection,
      latipayLogo,
      pmLogo,
      countryOptions: countryData,
      dialOptions: dialData,
      categories,
      operations,
      greenTick,
      resetForm,
      loading

    }
  },
  watch: {
    // Watch the 'sameAddress' checkbox
    'form.sameAddress': function (newVal) {
      if (newVal) {
        // If checked, copy the registered address to the operational address
        this.form.operationalAddress = {...this.form.registeredAddress};
      } else {
        // If unchecked, clear the operational address fields
        this.form.operationalAddress = {
          street: '',
          street2: '',
          city: '',
          state: '',
          postalCode: '',
          country: ''
        };
      }
    },
    // Keep the submitted currency in sync with Country of Incorporation
    'form.countryOfIncorporation': {
      immediate: true,
      handler() {
        this.sectionTwoForm.currency = this.localCurrency;
      }
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.input-with-select .el-input-group__prepend {
  background-color: var(--el-fill-color-blank);
}

.container {
  display: flex;
  justify-content: center; /* Center the container */
  align-items: flex-start; /* Align the items at the top */
  gap: 0px; /* Add space between form and timeline */
  background-image: url('@/assets/bg01.jpg');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  height: 100%;
  min-height: 100vh;
  margin-top: -100px;
}

.form-container {
  width: 40%;
  margin-right: 22%; /* Adjust width of form */
  margin-bottom: 100px;
  margin-top: 120px;
}

.tab-container {
  width: 22%; /* Adjust width of timeline */
  margin-top: 250px;
  /* Optional: add margin to adjust timeline's vertical position */
}

/* Vertical step navigation styling (desktop, tab-position="left") */
.tab-container :deep(.el-tabs__nav-wrap.is-left::after) {
  display: none; /* remove default divider line */
}

.tab-container :deep(.el-tabs__active-bar.is-left) {
  display: none; /* replaced by the pill background on the active item */
}

.tab-container :deep(.el-tabs__nav) {
  counter-reset: step;
}

.tab-container :deep(.el-tabs__item.is-left) {
  counter-increment: step;
  display: flex;
  align-items: center;
  gap: 10px;
  height: auto;
  line-height: 1.35;
  padding: 12px 14px !important;
  margin-bottom: 6px;
  border-radius: 10px;
  color: #667085;
  font-weight: 500;
  font-size: 15px;
  white-space: normal;
  text-align: left;
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.tab-container :deep(.el-tabs__item.is-left::before) {
  content: counter(step);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #f1f3f5;
  color: #667085;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}

.tab-container :deep(.el-tabs__item.is-left:hover) {
  background: rgba(64, 158, 255, 0.08);
  color: #409eff;
}

.tab-container :deep(.el-tabs__item.is-left.is-active) {
  background: linear-gradient(135deg, #409eff 0%, #67c23a 130%);
  color: #fff;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.28);
}

.tab-container :deep(.el-tabs__item.is-left.is-active::before) {
  background: rgba(255, 255, 255, 0.28);
  color: #fff;
}

.director-card {
  border: 1px solid var(--el-border-color, #dcdfe6);
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 16px;
  background: linear-gradient(180deg, #fafbfc 0%, #ffffff 100%);
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}

.director-card:hover {
  border-color: var(--el-color-primary-light-5, #a0cfff);
  box-shadow: 0 4px 12px rgba(16, 24, 40, 0.06);
}

/* ---- General visual polish (card, headings, buttons) ---- */
:deep(.el-card) {
  border-radius: 16px;
  border: none;
  box-shadow: 0 8px 30px rgba(16, 24, 40, 0.08), 0 2px 8px rgba(16, 24, 40, 0.04);
}

:deep(.el-card__body) {
  padding: 32px;
}

.section-title {
  position: relative;
  padding-left: 14px;
  border-bottom: none !important;
  color: #1d2939;
  letter-spacing: 0.2px;
}

.section-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 3px;
  bottom: 3px;
  width: 4px;
  border-radius: 2px;
  background: linear-gradient(180deg, #409eff 0%, #67c23a 100%);
}

.section-title::after {
  content: '';
  display: block;
  margin-top: 10px;
  height: 1px;
  background: linear-gradient(90deg, rgba(64, 158, 255, 0.25), rgba(0, 0, 0, 0));
}

:deep(.el-button--primary) {
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(64, 158, 255, 0.35);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

:deep(.el-button--primary:hover) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
}

:deep(.el-button) {
  border-radius: 8px;
}

:deep(.el-input__wrapper),
:deep(.el-textarea__inner) {
  border-radius: 8px;
}

.checkbox-text {
  white-space: normal; /* Allows the text to wrap */
  word-wrap: break-word; /* Breaks long words to prevent overflow */
  display: inline-block;
  max-width: 100%; /* Ensure it takes up full width for wrapping */
}

.field-label-with-info {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.field-info-icon {
  color: var(--el-text-color-placeholder, #a8abb2);
  cursor: help;
  font-size: 14px;
}

.field-info-icon:hover {
  color: var(--el-color-primary, #409eff);
}

.el-select {
  max-height: 400px; /* Adjust based on your needs */
  overflow-y: auto;
}

/* ---- Mobile / small screens ---- */
@media (max-width: 768px) {
  .container {
    flex-direction: column;
    background-attachment: scroll; /* fixed is janky on mobile */
    margin-top: 0;
    height: auto;
  }

  .tab-container {
    width: 100%;
    margin-top: 0;
    padding: 12px 12px 0;
    box-sizing: border-box;
  }

  /* Horizontal pill-style step nav, mirroring the desktop vertical nav */
  .tab-container :deep(.el-tabs__nav-wrap.is-top::after) {
    display: none; /* remove default divider line under the tabs */
  }

  .tab-container :deep(.el-tabs__active-bar.is-top) {
    display: none; /* replaced by the pill background on the active item */
  }

  .tab-container :deep(.el-tabs__nav) {
    counter-reset: step;
  }

  .tab-container :deep(.el-tabs__item.is-top) {
    counter-increment: step;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: auto;
    line-height: 1.2;
    padding: 7px 12px !important;
    margin: 0 4px 6px;
    border-radius: 999px;
    color: #667085;
    font-weight: 500;
    font-size: 14px;
    transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
  }

  .tab-container :deep(.el-tabs__item.is-top::before) {
    content: counter(step);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #f1f3f5;
    color: #667085;
    font-size: 11px;
    font-weight: 600;
    flex-shrink: 0;
  }

  .tab-container :deep(.el-tabs__item.is-top.is-active) {
    background: linear-gradient(135deg, #409eff 0%, #67c23a 130%);
    color: #fff;
    font-weight: 600;
    box-shadow: 0 3px 10px rgba(64, 158, 255, 0.28);
  }

  .tab-container :deep(.el-tabs__item.is-top.is-active::before) {
    background: rgba(255, 255, 255, 0.28);
    color: #fff;
  }

  .form-container {
    width: 100%;
    margin: 0 0 40px 0;
    padding: 0 12px;
    box-sizing: border-box;
  }

  /* Stack the two-column (el-row/el-col) layouts into a single column */
  :deep(.el-col) {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
  }

  /* Keep the phone country-dial prepend select from overflowing */
  :deep(.el-input-group__prepend .el-select) {
    width: 100px !important;
  }

  /* Let long declaration checkboxes wrap cleanly */
  :deep(.el-checkbox) {
    white-space: normal;
    height: auto;
  }

  /* Standalone full-width checkboxes (declarations, address checkboxes) —
     stack the box above/beside wrapped text without overlapping it */
  :deep(.checkbox-block) {
    display: flex;
    align-items: flex-start;
    white-space: normal;
    height: auto;
    line-height: 1.5;
    margin-right: 0;
    width: 100%;
  }

  :deep(.checkbox-block .el-checkbox__input) {
    margin-top: 3px; /* align the box with the first line of wrapped text */
    flex-shrink: 0;
  }

  :deep(.checkbox-block .el-checkbox__label) {
    white-space: normal;
    line-height: 1.5;
    padding-left: 8px;
  }

  /* Payment-method style checkbox groups that wrap onto multiple lines —
     add breathing room so labels don't touch the next checkbox */
  :deep(.el-checkbox-group .el-checkbox) {
    margin-right: 14px;
    margin-bottom: 10px;
  }

  /* Give wrapped declaration checkboxes breathing room so lines don't crowd each other */
  :deep(.el-form-item) {
    margin-bottom: 18px;
  }

  .section-title {
    font-size: 18px;
  }

  /* Radio groups (business type, nature of business, etc.) overflow the
     viewport on mobile since Element Plus radios default to nowrap labels —
     stack them vertically and let the label text wrap instead */
  :deep(.el-radio-group) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }

  :deep(.el-radio) {
    display: flex;
    align-items: flex-start;
    white-space: normal;
    height: auto;
    width: 100%;
    margin-right: 0;
    line-height: 1.5;
    margin-bottom: 10px;
  }

  :deep(.el-radio__input) {
    margin-top: 3px;
    flex-shrink: 0;
  }

  :deep(.el-radio__label) {
    white-space: normal;
    line-height: 1.5;
    padding-left: 8px;
    word-break: break-word;
  }

  :deep(.el-card__body) {
    padding: 20px 16px;
  }
}

</style>
